import React, { Component } from 'react';
import CryptoJS from 'crypto-js';
import { checkToken, currentUserBrief, userLogout, passwordExpire } from '@/api/login';
import { userSwitchTenant } from '@/api/tenant';
import { get } from '@/utils/http';
import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { qtBindUser, qtEnd, qtPagePv, getParam } from 'ruigu-utils';
import defaultIcon from '@/assets/images/placeholder.png';
import store from 'store';
/**
 * 返回数组
 * @param arr
 * @returns {*}
 */
export function getArray(arr) {
  return Array.isArray(arr) ? arr : [];
}

/**
 * 校验returnURL是否为允许跳转的安全地址
 * 仅放行http/https协议且域名为ruigushop.com或其子域的地址，
 * 拦截javascript:/data:等伪协议注入与任意外部域跳转
 */
export const isSafeReturnURL = (url) => {
  if (!url) return false;
  try {
    const { protocol, hostname } = new URL(url, window.location.origin);
    return (
      ['http:', 'https:'].includes(protocol) &&
      (hostname === 'ruigushop.com' || hostname.endsWith('.ruigushop.com'))
    );
  } catch (err) {
    return false;
  }
};

/**
 * 验证token有效性
 */
export const handleCheckToken = async (token, success) => {
  try {
    const res = await checkToken(token);
    const info = await currentUserBrief();
    const userInfo = { ...res, ...info };
    store.set('userInfo', userInfo);

    // 设置页签名字、icon
    document.title = userInfo.bizOrgText;
    document.getElementById('meta-icon').setAttribute('href', userInfo.logo || defaultIcon);

    // 上报
    console.log(
      `QT: 埋点上报-绑定用户id: qtBindUser(${info.nickname || res.nickname}(${
        info.userCode || res.user_id
      }))`,
    );
    qtBindUser(
      `${info.nickname || res.nickname}(${info.userCode || res.user_id})`,
    );

    // 校验是否来源第三方url授权页面
    const returnURL = window.sessionStorage.getItem('returnURL');
    window.sessionStorage.removeItem('returnURL');
    if (returnURL && isSafeReturnURL(returnURL)) {
      const splitArr = returnURL.split('?');
      window.location.href = `${splitArr[0]}?userCode=${info.userCode}&userId=${
        res.user_id
      }&nickName=${res.nickname || ''}&token=${token}${
        splitArr[1] ? '&' + splitArr[1] : ''
      }`;
    } else {
      success && success(userInfo);
      return userInfo;
    }
  } catch (err) {
    localStorage.clear();
    window.location.reload();
  }
};

// 退出登录
export const onExit = async (onlyExit) => {
  try {
    if (!store.get('token')) return;
    await userLogout({ access_token: store.get('token') });
    store.clearAll();
    qtEnd();
    if (!onlyExit) {
      window.location.reload();
    }
  } catch (err) {
    message.warning(err.message);
  }
};

/**
 * 判断是否为 QuickBI 报表地址，两类换票接口路径均命中：
 * rbox-data-pulse/api/v1/quick-bi/report 与 best-store-management/proxy/quick-bi/report
 */
export const isQuickBIReportUrl = (path) => {
  return /(rbox-data-pulse\/api\/v1|best-store-management\/proxy)\/quick-bi\/report/.test(path || '');
};

/**
 * QuickBI 报表换票：请求参数 isRedirect=false 时服务端不做 302 跳转，
 * 直接返回带 accessTicket 的报表地址；访问凭证由请求头 Authorization 携带
 */
export const fetchQuickBIReportUrl = async (reportUrl) => {
  const url = await get(reportUrl, { isRedirect: false });
  if (typeof url !== 'string' || !url) {
    throw new Error('[quickbi] 换票返回的报表地址无效');
  }
  return url;
};

// QT 上报
export const qtPagePvFun = (path) => {
  if (!path) return;
  // 去除末尾斜杠
  const startStr = path.split('?')[0];
  const pathStr = startStr.endsWith('/')
    ? startStr.substring(0, startStr.length - 1)
    : startStr;
  // 获取后缀 hash 模式
  const hashStr = pathStr.split('/#/');
  // 获取后缀 history(存在空格)
  const getEnd = hashStr[1] || hashStr[0].split('ruigushop.com/')[1];
  // 获取子域名
  const childDomain = hashStr[0]
    .replace(/test.|dev.|http:|https:|\/\//g, '')
    .split('.ruigushop.com')[0];
  // 特殊页面拼接区分，如：QuickBI
  let queryPath = '';
  if (/rbox-data-pulse\/api\/v1\/quick-bi\/report/.test(startStr)) {
    queryPath += path.split('reportId=')[1];
  }
  // 拼接code编码
  const pageCode = `launchpad_${childDomain || ''}${
    getEnd ? '_' + getEnd : ''
  }${queryPath ? '_' + queryPath : ''}_page`
    .replace(/-|\//g, '_')
    .replace(/:|#| /g, '');
  console.log(`QT上报编码：${pageCode}`);
  qtPagePv(pageCode);
};

// 根据token获取用户信息，并且跳转固定首页
export const hrefHomeByToken = async (
  access_token,
  bizOrgList,
  userInfo,
  history,
  beforeHrefFun
) => {
  try {
    store.set('iframeUser', { bizOrgList, userInfo });

    const returnURL = window.sessionStorage.getItem('returnURL');
    const loginType = JSON.parse(window.localStorage.getItem('loginType') || '{}');

    if (returnURL && isSafeReturnURL(returnURL)) {
      if (getParam('system') == 'cs') {
        // CS 平台直接切换租户到2
        await userSwitchTenant({
          bizOrgId: 2,
          clientId: process.env.REACT_APP_CLIENT_ID
        });
      }
      window.sessionStorage.removeItem('returnURL');
      const splitArr = returnURL.split('?');
      window.location.href = `${splitArr[0]}?userCode=${userInfo.userCode}&userId=${
        userInfo.id
      }&nickName=${userInfo.nickname || ''}&token=${access_token}${
        splitArr[1] ? '&' + splitArr[1] : ''
      }&loginType=${loginType.type}`;
    } else {
      window.sessionStorage.removeItem('returnURL');
      // 先切换租户(launchpad用户补偿租户身份)
      if (bizOrgList[0] && bizOrgList[0].id && checkIsLaunchpad()) {
        await userSwitchTenant({
          bizOrgId: bizOrgList[0].id,
          clientId: process.env.REACT_APP_CLIENT_ID
        });
      }
      // 外包跳转定制首页，内部和联盟跳转各自首页
      if (!checkIsLaunchpad()) {
        history.push('/home');
      } else if (bizOrgList.length > 1) {
        // beforeHrefFun && beforeHrefFun();
        history.push('/tenantSelect');
      } else {
        const res = await handleCheckToken(access_token);
        beforeHrefFun && beforeHrefFun();
        if ([1].includes(res.bizOrgType)) {
          history.push('/');
        } else {
          history.push('/home');
        }
      }
    }
  } catch (err) {
    message.warning(err.message);
  }
};

// 递归查询菜单key
export const getMenuInfoByUrl = (arr, keys, url) => {
  if (!url) return;
  const newUrl = url
    .replace(/http:\/\/|https:\/\/|\/\//, '')
    .replace(/test.|dev.|uat./, '')
    .split('?')[0];
  const newArr = arr
    .map((element) => {
      const openKeys = [String(element.id), ...keys];
      if (element.children && element.children.length > 0) {
        return getMenuInfoByUrl(element.children, openKeys, newUrl);
      } else {
        if (element.path && element.path.includes(newUrl)) {
          return {
            ...element,
            openKeys,
          };
        }
        return null;
      }
    })
    .filter((item) => item);
  return newArr[0];
}

// 根据菜单id 递归查询顶部和左边菜单栏
export const getMenuInfoById = (arr, keys = [], id) => {
  const strId = String(id);
  const newArr = arr
    .map((element) => {
      const openKeys = [String(element.id), ...keys];
      if (element.children && element.children.length > 0) {
        const children = getMenuInfoById(element.children, openKeys, strId);
        return children;
      } else {
        if (openKeys.includes(strId)) {
          return {
            ...element,
            openKeys,
          };
        }
        return null;
      }
    })
    .filter((item) => item);
  return newArr[0];
}

// 根据目录id 递归查询menulayout菜单栏
export const getMenuLayoutById = (arr, id) => {
  const strId = String(id);
  const newArr = arr
    .map((element) => {
      if (String(element.id) === strId) {
        return element
      } else {
        if (element.children && element.children.length > 0) {
          return getMenuLayoutById(element.children, strId);
        } else {
          return null;
        }
      }
    })
    .filter((item) => Array.isArray(item) ? item.length : item);
  return newArr[0];
}

// 返回个人中心入口配置
export const hrefUserHomeInfo = (tabActiveKey='1') => {
  const nemuObj = {
    production: {
      id: 880,
      path: `//pro.ruigushop.com/passport-personal-homepage?tabActiveKey=${tabActiveKey}`
    },
    development: {
      id: 1051,
      path: `//dev.pro.ruigushop.com/passport-personal-homepage?tabActiveKey=${tabActiveKey}`
    },
    test: {
      id: 1051,
      path: `//test-pro.ruigushop.com/passport-personal-homepage?tabActiveKey=${tabActiveKey}`
    },
  };
  const path = nemuObj[process.env.REACT_APP_ENV].path;
  return {
    backPath: path,
    path,
    title: '个人主页',
    type: 0,
    id: nemuObj[process.env.REACT_APP_ENV].id,
  };
}

// 首页查询密码有效期进行提醒
export const checkPasswordExpiration = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!store.get('token') && !store.get('userInfo')) return reject();
      const userId = store.get('userInfo')?.id;
      const { nearExpire, expireRemind } = await passwordExpire(userId);
      if (!nearExpire) return reject();
      Modal.confirm({
        title: expireRemind,
        icon: <ExclamationCircleOutlined />,
        okText: '去修改',
        cancelText: '关闭',
        className: 'comon-modal-body',
        onOk: () => {
          window.localStorage.setItem('loginType', JSON.stringify({
            isAlert: true,
          }));
          resolve(true);
        },
        onCancel() {
          window.localStorage.setItem('loginType', JSON.stringify({
            isAlert: true,
          }));
          reject();
        },
      });
    } catch (err) {
      message.warning(err.message);
      reject();
    }
  });
};

// 查询是launchpad还是外部地址
export const checkIsLaunchpad = () => {
  return process.env.REACT_APP_URL.includes('launchpad') || process.env.REACT_APP_URL.includes('launchpad');
}

/** 禅道免登录配置 */
const ZENTAO_LOGIN_CONFIG = {
  baseUrl: 'https://pm.ruigushop.com',
  appCode: 'qwlogin',
  appKey: 'l9nz7sfv480w5bh1po9v8v865ln8gygq',
};

/**
 * @description 获取当前登录用户的禅道账号（工号）。
 * @returns {string} 当前用户工号
 */
export const getZentaoAccount = () => {
  const userInfo = store.get('userInfo') || {};
  return userInfo.userCode || '';
};

/**
 * @description 执行禅道免登录跳转。
 * @description 根据当前登录用户工号、禅道接口规则生成秒级时间戳与 MD5 token，优先打开新窗口；当浏览器拦截新窗口时，在当前窗口跳转。
 */
export const zentaoLogin = () => {
  const account = getZentaoAccount();

  if (!account) {
    message.warning('未获取到当前用户工号，请重新登录后再试');
    return;
  }

  const ts = Math.floor(Date.now() / 1000);
  const token = CryptoJS.MD5(
    `${ZENTAO_LOGIN_CONFIG.appCode}${ZENTAO_LOGIN_CONFIG.appKey}${ts}`,
  ).toString();
  const query = new URLSearchParams({
    m: 'user',
    f: 'apilogin',
    account,
    code: ZENTAO_LOGIN_CONFIG.appCode,
    time: String(ts),
    token,
    referer: ZENTAO_LOGIN_CONFIG.baseUrl,
    redirect_to: ZENTAO_LOGIN_CONFIG.baseUrl,
  });
  const url = `${ZENTAO_LOGIN_CONFIG.baseUrl}/api.php?${query.toString()}`;
  // 浏览器可能拦截非用户直接触发的新窗口，拦截时退回当前窗口跳转。
  const win = window.open(url, '_blank');
  if (!win) {
    window.location.href = url;
  }
};

/**
 * @description 判断菜单是否为禅道入口，如果是则执行免登录跳转。
 * @param {object} params - 菜单数据，需包含 permCode 字段
 * @returns {boolean} 是否命中禅道跳转（true 表示已处理，调用方应 return）
 */
export const handleZentaoRedirect = (params) => {
  if (params.permCode === 'new-zentao') {
    zentaoLogin();
    return true;
  }
  return false;
};
